Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.KeyLocation = module.exports.default = {
	LEFT: 1,
	NUM_PAD: 3,
	RIGHT: 2,
	STANDARD: 0
};